import { Sliders, X } from "lucide-react";
import React from "react";

interface Props {
  gains: number[];
  onGainChange: (index: number, value: number) => void;
  onClose: () => void;
}

const BANDS = ["60Hz", "300Hz", "1kHz", "3kHz", "10kHz"];

const Equalizer: React.FC<Props> = ({ gains, onGainChange, onClose }) => {
  return (
    <div className="absolute bottom-full mb-4 left-1/2 -translate-x-1/2 bg-radio-surface/95 backdrop-blur-xl border border-white/10 p-6 rounded-2xl shadow-2xl w-[320px] z-50 animate-[slideUp_0.2s_ease-out]">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-white font-bold text-sm tracking-wider flex items-center gap-2">
          <Sliders className="text-radio-accent" size={14} />
          EQUALIZER
        </h3>
        <button onClick={onClose} className="text-gray-400 hover:text-white">
          <X size={14} />
        </button>
      </div>

      <div className="flex justify-between items-end h-32 gap-2">
        {gains.map((gain, i) => (
          <div key={i} className="flex flex-col items-center h-full group">
            <div className="relative flex-1 w-8 bg-black/40 rounded-full overflow-hidden border border-white/5">
              {/* Track line */}
              <div className="absolute left-1/2 top-2 bottom-2 w-0.5 bg-gray-700 -translate-x-1/2"></div>

              {/* Slider Input */}
              <input
                type="range"
                min="-12"
                max="12"
                step="1"
                value={gain}
                onChange={(e) => onGainChange(i, parseFloat(e.target.value))}
                className="absolute inset-0 w-full h-full opacity-0 cursor-pointer z-20"
                style={
                  { WebkitAppearance: "slider-vertical" } as React.CSSProperties
                }
              />

              {/* Visual Thumb */}
              <div
                className="absolute left-1 right-1 h-1.5 bg-radio-accent rounded-full shadow-[0_0_10px_#06b6d4] transition-all duration-75 pointer-events-none z-10"
                style={{ bottom: `${((gain + 12) / 24) * 80 + 10}%` }}
              ></div>
            </div>
            <span className="text-[10px] font-mono text-gray-500 mt-2 group-hover:text-gray-300 transition-colors">
              {BANDS[i]}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Equalizer;
